<template>
  <div>
    <img
      ref="floorplanImage"
      class="enlarge-floorplan-image"
      :src="floorplan"
      @load="onResize()"
    >
    <floorplan-dots
      class="dots-init-positioning"
      :ratio="positionRatio"
      :ratio-rfe="positionRatioRfe"
      :x-offset="xOffset"
      :y-offset="yOffset"
      :scale="pointScale"
      @selectedPanorama="onSelectedPanorama"
    />
    <floorplan-range
      class="dots-init-positioning"
      :ratio="positionRatio"
      :ratio-rfe="positionRatioRfe"
      :x-offset="xOffset"
      :y-offset="yOffset"
      :scale="pointScale"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FloorplanDots from './FloorplanDots.vue'
import FloorplanRange from './FloorplanRange.vue'

export default {
  name: 'EnlargeFloorplan',

  components: {
    FloorplanRange,
    FloorplanDots
  },

  data () {
    return {
      // --- Constant ---
      // Difference size of point between Viewer and Editor. (Viewer: 20px * 20px, Editor: 25.7px * 30px)
      xBaseOffset: 2.85,
      yBaseOffset: 5,
      // Editor's size limit.
      editorMaxWidth: 600,
      editorMaxHeight: 450,

      // Origin image size.
      floorplanWidth: 0,
      floorplanHeight: 0,
      positionRatio: 0,
      positionRatioRfe: 0,
      pointScale: 1,
      xOffset: 0,
      yOffset: 0
    }
  },

  computed: {
    ...mapGetters([
      'floorplan'
    ])
  },

  mounted () {
    if (this.floorplan) {
      const image = new Image()
      image.src = this.floorplan
      image.onload = () => {
        this.floorplanWidth = image.width
        this.floorplanHeight = image.height
        this.onResize()
      }
    }
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },

  methods: {
    ...mapActions([
      'closeFloorplan'
    ]),

    onResize () {
      // const ratioPoint = this.getRatioOfPoint()
      // this.xOffset = this.xBaseOffset * ratioPoint
      // this.yOffset = this.yBaseOffset * ratioPoint
      this.positionRatio = this.getRatioOfPhoto()
      this.positionRatioRfe = this.getRatioOfPhotoRfe()
      this.pointScale = this.getRatioOfPoint()
    },

    getRatioOfPhoto () {
      // Scale for origin image size and container size.
      const imgHeight = this.$refs.floorplanImage.height
      const imgWidth = this.$refs.floorplanImage.width
      const scaleHeight = imgHeight / this.floorplanHeight || 1
      const scaleWidth = imgWidth / this.floorplanWidth || 1
      return Math.min(scaleHeight, scaleWidth, 1)
    },

    getRatioOfPhotoRfe () {
      // Scale for origin image size and container size.
      const scaleHeight = this.editorMaxHeight / this.floorplanHeight || 1
      const scaleWidth = this.editorMaxWidth / this.floorplanWidth || 1
      return Math.min(scaleHeight, scaleWidth, 1)
    },

    getRatioOfPoint () {
      // Scale for Editor limit and container size.
      // Influences point's position and size.
      const imgHeight = this.$refs.floorplanImage.height
      const imgWidth = this.$refs.floorplanImage.width
      const scaleHeight = imgHeight / this.editorMaxHeight || 1
      const scaleWidth = imgWidth / this.editorMaxWidth || 1
      return Math.max(scaleHeight, scaleWidth, 1)
    },

    onSelectedPanorama () {
      setTimeout(() => {
        this.closeFloorplan()
      }, 1000)
    }
  }
}
</script>

<style>
.enlarge-floorplan-image {
  max-width: 80vw;
  max-height: 80vh;
  object-fit: contain;
  display: block;
}
.dots-init-positioning {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
